import {CurrencyPipe, HashLocationStrategy, LocationStrategy} from '@angular/common';
import {RouterModule} from '@angular/router';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {AppComponent} from './app.component';
import {ApiService} from './services/api.service';
import {SharedModule} from './shared/shared.module';
import {LoaderComponent} from './shared/loader/loader.component';
import {CommonUtils} from './services/common-utils';
import {AppHttpInterceptor} from './interceptors/AppHttpInterceptor';
import {LoaderInterceptor} from './interceptors/loader-interceptor';
import {ErrorService} from './shared/error-page/service/error-service';
import {AppRoutingModule} from './app-routing.module';
import { HomeComponent } from './modules/home/home.component';
import { ReverseMortgageComponent } from './modules/reverse-mortgage/reverse-mortgage.component';
import { SearchUpdateLoanFormComponent } from './modules/reverse-mortgage/search-update-loan-form/search-update-loan-form.component';
import {FormsModule} from '@angular/forms';
import {AdminModule} from './modules/admin/admin.module';
import { QueryTransactionsComponent } from './modules/reverse-mortgage/query-transactions/query-transactions.component';
import { QueryLoansComponent } from './modules/reverse-mortgage/query-loans/query-loans.component';
import { QueryLoansResultComponent } from './modules/reverse-mortgage/query-loans-result/query-loans-result.component';
import {QueryLoanDetailsComponent} from './modules/reverse-mortgage/query-loans-details/query-loans-details.component';
import {SearchUpdateResultComponent} from './modules/reverse-mortgage/search-update-result/search-update-result.component';
import {UtilityService} from './services/utility-service';
import { LoanDetailsComponent } from './modules/reverse-mortgage/loan-details/loan-details.component';
import { ViewTransmissionComponent } from './modules/reverse-mortgage/view-transmission/view-transmission.component';
import { QueryTransactionsResultsComponent } from './modules/reverse-mortgage/query-transactions-results/query-transactions-results.component';
import { QueryTransactionDetailsComponent } from './modules/reverse-mortgage/query-transaction-details/query-transaction-details.component';
import {AuthguardServiceService} from './services/authguard-service.service';
import { UploadFileComponent } from './modules/reverse-mortgage/upload-file/upload-file.component';
import {QueryServicerTransfersComponent} from './modules/reverse-mortgage/query-servicer-transfers/query-servicer-transfers.component';
import { PerformTransactionsComponent } from './modules/reverse-mortgage/perform-transactions/perform-transactions.component';
import { CalculateLoanPayOffComponent } from './modules/reverse-mortgage/perform-transactions/calculate-loan-pay-off/calculate-loan-pay-off.component';
import { PartpaymentComponent } from './modules/reverse-mortgage/perform-transactions/partpayment/partpayment.component';
import { UnscheduledComponent } from './modules/reverse-mortgage/perform-transactions/unscheduled/unscheduled.component';
import { LoanpayoffComponent } from './modules/reverse-mortgage/perform-transactions/loanpayoff/loanpayoff.component';
import { ServicerTransfersResultsComponent } from './modules/reverse-mortgage/servicer-transfers-results/servicer-transfers-results.component';
import { ServiceTranferApproveDeleteComponent } from './modules/reverse-mortgage/service-tranfer-approve-delete/service-tranfer-approve-delete.component';
import { ServiceTransferPortfolioIndicatorComponent } from './modules/reverse-mortgage/servicer-transfers-results/service-transfer-portfolio-indicator/service-transfer-portfolio-indicator.component';
import { ServicetransferComponent } from './modules/reverse-mortgage/perform-transactions/servicetransfer/servicetransfer.component';
import { ServiceTransferLoanSelectComponent } from './modules/reverse-mortgage/perform-transactions/servicetransfer/service-transfer-loan-select/service-transfer-loan-select.component';
import { loanStatusMaintneComponent } from './modules/reverse-mortgage/perform-transactions/loanStatusMain/loanStatusMaintne.component';
import { paymentChangeComponent } from './modules/reverse-mortgage/perform-transactions/paymentChange/paymentChange.component';
import { QueryTransactionsDeleteComponent } from './modules/reverse-mortgage/query-transactions-delete/query-transactions-delete.component';
import { ContactInfoComponent } from './modules/reverse-mortgage/contact-info/contact-info.component';
import { HelpComponent } from './help/help.component';
import { SubmitTrialBalanceComponent } from './modules/reverse-mortgage/submit-trial-balance/submit-trial-balance.component';
import { TrialBalanceResultComponent } from './modules/reverse-mortgage/trial-balance-result/trial-balance-result.component';
import { AccountingReportsComponent } from './modules/reverse-mortgage/accounting-reports/accounting-reports.component';
import { DeliveryReportsComponent } from './modules/reverse-mortgage/delivery-reports/delivery-reports.component';
import { PurchasingFeeReportsComponent } from './modules/reverse-mortgage/delivery-reports/purchasing-fee-reports/purchasing-fee-reports.component';
import { ReportsCreiteriaComponent } from './shared/reports-creiteria/reports-creiteria.component';
import { AccountingViewPurchaseAdviceComponent } from './modules/reverse-mortgage/accounting-view-purchase-advice/accounting-view-purchase-advice.component';
import { DeliveryViewPurchaseAdviceComponent } from './modules/reverse-mortgage/delivery-view-purchase-advice/delivery-view-purchase-advice.component';
import { FmComponentsModule } from '@fm-ui-adk/components-3/components_module';
import { ConfirmationService } from '@fm-ui-adk/components-3/common/services';

@NgModule({
  declarations: [
    AppComponent,
    LoaderComponent,
    ReverseMortgageComponent,
    HomeComponent,
    SearchUpdateLoanFormComponent,
    QueryTransactionsComponent,
    QueryLoansComponent,
    QueryLoansResultComponent,
    SearchUpdateResultComponent,
    LoanDetailsComponent,
    ViewTransmissionComponent,
    QueryTransactionsResultsComponent,
    UploadFileComponent,
    PartpaymentComponent,
    paymentChangeComponent,
    loanStatusMaintneComponent,
    UnscheduledComponent,
    QueryServicerTransfersComponent,
    PerformTransactionsComponent,
    QueryLoanDetailsComponent,
    CalculateLoanPayOffComponent,
    LoanpayoffComponent,
    ServicerTransfersResultsComponent,
    QueryLoanDetailsComponent,
    QueryTransactionDetailsComponent,
    ServiceTranferApproveDeleteComponent,
    ServiceTransferPortfolioIndicatorComponent,
    ContactInfoComponent,
    ServicetransferComponent,
    ServiceTransferLoanSelectComponent,
    HelpComponent,
    QueryTransactionsDeleteComponent,
    SubmitTrialBalanceComponent,
    TrialBalanceResultComponent,
    AccountingReportsComponent,
    DeliveryReportsComponent,
    PurchasingFeeReportsComponent,
    ReportsCreiteriaComponent,
    AccountingViewPurchaseAdviceComponent,
    DeliveryViewPurchaseAdviceComponent
  ],
  imports: [
    BrowserModule,
    FmComponentsModule.forRoot(),
    BrowserAnimationsModule,
    HttpClientModule,
    AdminModule,
    AppRoutingModule,
    SharedModule,
    FormsModule
  ],
  exports: [
    FmComponentsModule,
    RouterModule,
    HttpClientModule
  ],
  providers: [{provide: LocationStrategy, useClass: HashLocationStrategy},
    CommonUtils,
    CurrencyPipe,
    ApiService,
    ErrorService,
    AuthguardServiceService,
    UtilityService,
    ConfirmationService, { provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
